import { Dispatch, MutableRefObject, createContext, } from 'react';
// 常量
import { DragDropOption, DragGridProps, DropfullScreenActionType, IGridUseData, } from '../interface';
import { DragDropReducerAction } from '../reducer/dragDropReducer';

export interface IDragDropContext {
  /** 网格数 */
  grid: number;
  /** 单个网格高度 */
  height: number;
  /** 单个网格宽度 */
  width: number;
  /** 容器高度 */
  wrapHeight: number;
  /** 容器宽度 */
  wrapWidht: number;
  /** 拖动项集合 */
  dragItems: DragDropOption[];
  /** 全局设置是否可以拖动 */
  isMove?: boolean;
  /** 全局设置是否可以改变大小 */
  isChangeSize?: boolean;
  /** 网格配置 null则不显示 */
  gridConfig?: DragGridProps | null;
  /** 网格占用情况数据 */
  gridUseData?: IGridUseData[];
  /** 点击操作按钮 */
  onClickOperation?: (key: string, widgetInfo: DragDropOption) => void;
  /** 点击其他操作按钮 */
  onClickOtherOperation?: (key: string, widgetInfo: DragDropOption) => void;
  /** DragDropRef */
  dragDropRef?: MutableRefObject<any>;
  /** 全屏 */
  dropfullScreenRef?: MutableRefObject<DropfullScreenActionType>;
}

export const DragDropContext = createContext<IDragDropContext>({
  dragItems: [],
  wrapWidht: 0,
  wrapHeight: 0,
  grid: 12,
  width: 0,
  height: 120,
  isMove: true,
  isChangeSize: true,
});
export const DragDropDispatchContext = createContext<Dispatch<DragDropReducerAction> | null>(null);
